<script setup lang="ts">
import { useSkyBreakpoint } from '@groveco/skylight'

const {
  meta: { showNotificationBar = false },
} = useRoute()
const { isExpanded } = useSearchSuggestions()
const { isReady, isLargeUp } = useSkyBreakpoint()
</script>

<template>
  <header class="TheHeader" :class="{ 'TheHeader--sticky': isExpanded }">
    <TheNotificationBar v-if="isReady && showNotificationBar" />
    <TheHeaderNavigation />
    <TheHeaderMenu v-if="isLargeUp" />
    <div v-if="!isReady" class="TheHeader_MenuPlaceholder" />
  </header>
</template>

<style lang="scss">
.TheHeader {
  background-color: var(--surface-color-dark);

  // sticky header must be above other sticky elements.
  &--sticky {
    position: sticky;
    top: 0;
    left: 0;
    z-index: calc(var(--z-index-sticky) + 1);
  }

  &_MenuPlaceholder {
    @include for-large-up {
      height: 50px;
      background-color: var(--surface-color-default);
    }
  }
}
</style>
